import { Message,Loading } from 'element-ui';
import instance from './interceptor'
// import Vue from "vue";
import api from "./api"
/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 */
function Randomnumber(){
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array.toString()
}
function electronicSignature (headers,sign,method,params,url,number,timestamp,resolve,reject,loadingInstance,Json){
    let data = {}
    headers = headers || {"Content-Type": "application/json"}
    // get请求使用params字段
    if(method =='get') data = {params}
    // post请求使用data字段
    if(method =='post') {
        data = !url.includes("Login") ? {
            data:{
                req_id:number,
                method:url,
                sign:sign,
                timestamp:timestamp,
                data:params
            }
        }:{data:params}
    }
    instance({
        url,
        method,
        headers,
        ...data
    }).then((res)=>{
    if (res == undefined) {
        Message.error(Json)
        return
    }
    // 此处作用很大，可以扩展很多功能。
    // 比如对接多个后台，数据结构不一致，可做接口适配器
    // 也可对返回日期/金额/数字等统一做集中处理
    if(res.return_codes == 0 || res.return_codes==-1 || res.return_codes==1 || res.return_codes==2 || res.return_codes==-2){
        resolve(res);
        if(res.return_codes==-1 || res.return_codes==-2) {
            Message.warning({showClose: true,message:res.return_msg})
            // Vue.prototype.$confirm(res.return_msg, '系统通知', {
            //     confirmButtonText: '确定',
            //     type: 'error'
            // })
        }
    }else{
        Message.error(res)
        reject(res);
    }
    }).catch((error)=>{
        console.log(error);
        resolve(error);
        // Message.error('请求失败，请重新登陆!')
        Message.error('请求失败，请重新登陆!')
    }).finally((error)=>{
        resolve(error);
        if(loadingInstance) loadingInstance.close();
    })
}
function request3(url,params,headers,options={loading:false},method){
    let number = Randomnumber()
    let sign
    let loadingInstance;
    // 请求前loading
    if(options.loading)loadingInstance=Loading.service({
        target:'#main',
        spinner:'el-icon-loading',
        text:'加载中',
        background:"rgba(0, 0, 0, 0.6)"
    });
    return new Promise((resolve)=>{
        //此处有一个重要逻辑，在请求所有的接口之前，需要先请求一下签名接口获取签名
        if(XMLHttpRequest){  //如果有XMLHttpRequest，那就是非IE6浏览器。()里面加window的原因下面会有描述。
            var oAjax = new XMLHttpRequest();//创建ajax对象
        }else{   //如果没有XMLHttpRequest，那就是IE6浏览器
            // var oAjax = new ActiveXObject("Microsoft.XMLHTTP");//IE6浏览器创建ajax对象
            Message.error('当前浏览器不支持，请使用新版浏览器')
        }
        const token = localStorage.getItem('token')
        const SYSUser = localStorage.getItem('SYSUser')
        let timestamp = new Date().valueOf()
        oAjax.open("POST",`${api}AULogin/SecureBySign`,true);
        let json = {
            req_id:number,
            method:url,
            sign:'',
            timestamp:timestamp,
            data:params
        }
        var obj = JSON.stringify(json);//将JS转为JSON
        oAjax.setRequestHeader('Content-Type','application/json; charset=utf-8')
        oAjax.setRequestHeader('MyAuthentication',token)
        oAjax.setRequestHeader('SYSUser',SYSUser)
        oAjax.send(obj);
        oAjax.onreadystatechange = function() {
            if (oAjax.readyState === 4) {
                if ( (oAjax.status >= 200 && oAjax.status <= 300) || oAjax.status === 304 ) {
                    let Json  = eval("(" + oAjax.response + ")")
                    sign = Json.return_data
                }
                else {
                    // alert("失败" + oAjax.status);
                    console.log('失败' + oAjax);
                }
            }
        }
        setTimeout(()=>{
            let data = {}
            headers = headers || {"Content-Type": "application/json"}
            // get请求使用params字段
            if(method =='get') data = {params}
            // post请求使用data字段
            if(method =='post') {
                data = !url.includes("Login") ? {
                    req_id:number,
                    method:url,
                    sign:sign,
                    timestamp:timestamp,
                    data:params
                }:{data:params}
            }
            instance({
                url,
                method,
                headers,
                responseType: 'blob',
                data
            }).then((res)=>{
                // 此处作用很大，可以扩展很多功能。
                // 比如对接多个后台，数据结构不一致，可做接口适配器
                // 也可对返回日期/金额/数字等统一做集中处理
                if(res.type == 'application/octet-stream'){
                    resolve(res)
                }else{
                    const file = new FileReader()
                    file.readAsText(res,'utf-8')
                    file.onload=function(){
                        const message=JSON.parse(file.result);
                        Message.error(message.return_msg)
                    }
                }
            }).catch((error)=>{
                console.log(error)
            }).finally(()=>{
                if(loadingInstance) loadingInstance.close();
            })
        },100)
    })
}
function request(url,params,headers,options={loading:false},method){
    let number = Randomnumber()
    let sign
    let loadingInstance;
    // 请求前loading
    if(options.loading)loadingInstance=Loading.service({
        target:'#main',
        spinner:'el-icon-loading',
        text:'加载中',
        background:"rgba(0, 0, 0, 0.6)"
    });
    return new Promise((resolve,reject)=>{
        if (url == 'AULogin/Login') {
            console.log('登录');
        }else{  //登录界面跳过
            //此处有一个重要逻辑，在请求所有的接口之前，需要先请求一下签名接口获取签名
            if(XMLHttpRequest){  //如果有XMLHttpRequest，那就是非IE6浏览器。()里面加window的原因下面会有描述。
                var oAjax = new XMLHttpRequest();//创建ajax对象
            }else{   //如果没有XMLHttpRequest，那就是IE6浏览器
                // var oAjax = new ActiveXObject("Microsoft.XMLHTTP");//IE6浏览器创建ajax对象
                Message.error('当前浏览器不支持，请使用新版浏览器')
            }
            const token = localStorage.getItem('token')
            const SYSUser = localStorage.getItem('SYSUser')
            var timestamp = new Date().valueOf()
            oAjax.open("POST",`${api}AULogin/SecureBySign`,true);
            let json = {
                req_id:number,
                method:url,
                sign:'',
                timestamp:timestamp,
                data:params
            }
            var obj = JSON.stringify(json);//将JS转为JSON
            oAjax.setRequestHeader('Content-Type','application/json; charset=utf-8')
            oAjax.setRequestHeader('MyAuthentication',token)
            oAjax.setRequestHeader('SYSUser',SYSUser)
            oAjax.send(obj);
            oAjax.onreadystatechange = function() {
                if (oAjax.readyState === 4) {
                    if ( (oAjax.status >= 200 && oAjax.status <= 300) || oAjax.status === 304 ) {
                        let Json  = eval("(" + oAjax.response + ")")
                        sign = Json.return_data
                        electronicSignature(headers,sign,method,params,url,number,timestamp,resolve,reject,loadingInstance,Json)
                    }
                    else {
                        // alert("失败" + oAjax.status);
                        console.log('失败' + oAjax);
                    }
                }
            }
        }
    })
}

function request2(url,params,headers,options={loading:false},method){
    let loadingInstance;
    // 请求前loading
    if(options.loading)loadingInstance=Loading.service({
        target:'#main',
        spinner:'el-icon-loading',
        text:'加载中',
        background:"rgba(0, 0, 0, 0.6)"
    });
    return new Promise((resolve,reject)=>{
        let data = {}
        headers = headers || {"Content-Type": "application/json"}
        // get请求使用params字段
        if(method =='get') data = {params}
        // post请求使用data字段
        if(method =='post') {
            data = !url.includes("Login") ? {
                data:params
            }:{data:params}
        }
        instance({
            url,
            method,
            headers,
            ...data
        }).then((res)=>{
            // 此处作用很大，可以扩展很多功能。
            // 比如对接多个后台，数据结构不一致，可做接口适配器
            // 也可对返回日期/金额/数字等统一做集中处理
            if(res.return_codes == 0 || res.return_codes==-1 || res.return_codes==1 || res.return_codes==2 || res.return_codes==-2){
                if(res.return_codes==-1) Message.warning(res.return_msg)
                resolve(res);
            }else{
                Message.error(res.return_msg)
                reject(res);
            }
        }).catch((error)=>{
            Message.error(error.msg)
        }).finally(()=>{
            if(loadingInstance) loadingInstance.close();
        })
    })
}
// 封装GET请求
function get(url,params,options){
    return request(url,params,null,options,'get')
}
// 封装POST请求
function post(url,params,header,options){
    return request(url,params,header,options,'post')
}
// 封装POST请求
function post2(url,params,header,options){
    return request2(url,params,header,options,'post')
}
// 封装POST请求
function post3(url,params,header,options){
    return request3(url,params,header,options,'post')
}
// 封装UPload请求
function upload(url,data,options){
    let loadingInstance;
    // 请求前loading
    if(options.loading)loadingInstance=Loading.service({
        target:'#main',
        spinner:'el-icon-loading',
        text:'加载中',
        background:"rgba(0, 0, 0, 0.6)"
    });
    return new Promise((resolve,reject)=>{
        instance({
            url,
            method:'post',
            headers:{
                "Content-type":'multipart/form-data'
            },
            data,
        }).then((res)=>{
            // 此处作用很大，可以扩展很多功能。
            // 比如对接多个后台，数据结构不一致，可做接口适配器
            // 也可对返回日期/金额/数字等统一做集中处理
            if(res.return_codes == 0 || res.return_codes==-1){
                if(res.return_codes==-1) Message.warning(res.return_msg)
                resolve(res);
            }else{
                Message.error(res.return_msg)
                reject(res);
            }
        }).catch((error)=>{
            console.log(error)
            resolve(error);
            // Message.error(error.msg)
        }).finally((error)=>{
            resolve(error);
            if(loadingInstance) loadingInstance.close();
        })
    })
}
export default {
    get, post, upload, post2,post3
}